import { Locale } from "./_locale";
import { AppRouter } from "./_router";
import { Theme } from "./_theme";
import { BrowserRouter } from "react-router-dom";
import Notification from "./_notification";
import { Loader } from "@components/loader";
import { useEffect, useState } from "react";
import { ReadCookie } from "@services/cookie";
import { CookieKeys } from "@config";
import { UserProvider } from "@contexts/user";

const Startup = () => {
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    const CookieRefreshToken = ReadCookie(CookieKeys.REFRESH_TOKEN);
    if (CookieRefreshToken) {
      setReady(true);
    } else {
      window.location.replace(window._env_.WEB_DASHBOARD || "");
    }
  }, []);

  if (ready)
    return (
      <UserProvider>
        <Theme>
          <Notification>
            <Locale>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </Locale>
          </Notification>
        </Theme>
      </UserProvider>
    );
  else return <Loader />;
};

export { Startup };
